import { useEffect } from 'react';
import { useAuth } from './useAuth';
import { usePortalAuth } from './usePortalAuth';
import { useThemeStore } from '@/stores/theme';

/**
 * Keeps the UI theme in sync with the authenticated staff user's preference.
 * Falls back to the value already persisted in localStorage when the user
 * is not available (e.g. before hydration).
 */
export function useThemeSync() {
  const { user } = useAuth();
  const syncTheme = useThemeStore((state) => state.syncTheme);

  useEffect(() => {
    if (user?.themePreference) {
      syncTheme(user.themePreference);
    }
  }, [user?.themePreference, syncTheme]);
}

/**
 * Keeps the UI theme in sync with the authenticated empresa (portal) user's
 * preference. Mirrors useThemeSync for the staff app.
 */
export function usePortalThemeSync() {
  const { user } = usePortalAuth();
  const syncTheme = useThemeStore((state) => state.syncTheme);

  useEffect(() => {
    if (user?.themePreference) {
      syncTheme(user.themePreference);
    }
  }, [user?.themePreference, syncTheme]);
}
